<gridster [options]="options">
  <gridster-item [item]="item.gridsterItem" *ngFor="let item of widgetConfigs">
      <app-chart class="app-widget" [widgetConfig]=item [devices]="devices" *ngIf="item.display_type==='chart'"></app-chart>
      <app-table class="app-widget" [widgetConfig]=item [devices]="devices" *ngIf="item.display_type==='plain'"></app-table>
      <app-map class="app-widget" [widgetConfig]=item [devices]="devices" *ngIf="item.display_type==='map'"></app-map>
  </gridster-item>
</gridster>
